var _namedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDreamBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Dream_op",
    width: "83.424mm",
    height: "61.035mm",
    viewBox: "0 0 83.424 61.035",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    "fit-margin-bottom": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-top": 0,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.996 -31.965)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.517 83 25.981-15-25.981-15",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.158 53 7.7942 4.5 7.7942-4.5",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 103.92,80 82.269,67.5 103.92,55",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#1a1a1a"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: -0.43959033,
    y: 11.094068,
    fill: "#fffffe",
    fontFamily: "sans-serif",
    fontSize: "7.6294px",
    letterSpacing: "0px",
    strokeWidth: 0.35763,
    wordSpacing: "0px",
    style: {
      fill: "#000000",
      lineHeight: 0.55
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.43959033,
    y: 11.094068,
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#fffffe",
    fontFamily: "sans-serif",
    fontSize: "15.259px",
    fontStyle: "italic",
    fontWeight: "bold",
    strokeWidth: 0.35763,
    style: {
      fill: "#000000"
    }
  }, "DReaM")), /*#__PURE__*/React.createElement("tspan", {
    x: -0.43959033,
    y: 19.580479,
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#000000"
    }
  }, "Driver Reaction Mode"), "l")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.996 -31.965)",
    stroke: "#fff",
    strokeLinejoin: "round",
    style: {
      stroke: "#000"
    },
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56.292,-892.5)",
    strokeWidth: 0.7,
    style: {
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    style: {
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.933 972.5v2",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.603 980v-3l4.3301-2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.603 977 4.3301 2.5v3l-4.3301-2.5v-3",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 977-4.3301 2.5-4.3301-2.5 4.3301-2.5 4.3301 2.5",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 980-4.3301 2.5v-3l4.3301-2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 977.5-4.3301 2.5",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 977.5 4.327-2.5",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.92 975v-3l-4.3301 2.5",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 969.5 4.3301 2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.933 972.5 4.3301-2.5 4.3301 2.5-4.3301 2.5z",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 974.5 4.3301-2.5-4.3301-2.5",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 969.5-2.6317 1.5194",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 975v2",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 972.5v2",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m92.802 979.96c0.32873-0.56938 1.1388-1.3149 1.7081-0.9862l0.46978 0.27719c0.56938 0.32873 0.32873 1.403 0 1.9724-0.32874 0.56938-1.1388 1.3149-1.7082 0.98619l-0.46977-0.27719c-0.56938-0.32873-0.32874-1.403 0-1.9724",
    fill: "#fff",
    stopColor: "#000000",
    style: {
      fill: "#000",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.53 975.59c0.32873-0.56938 1.1388-1.3149 1.7081-0.9862l0.46978 0.27719c0.56938 0.32873 0.32873 1.403 0 1.9724-0.32874 0.56938-1.1388 1.3149-1.7082 0.98619l-0.46977-0.27719c-0.56938-0.32873-0.32874-1.403 0-1.9724",
    fill: "#fff",
    stopColor: "#000000",
    style: {
      fill: "#000",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,178.4,-898)",
    strokeWidth: 0.7,
    style: {
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    style: {
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.933 972.5v2",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.603 980v-3l4.3301-2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.603 977 4.3301 2.5v3l-4.3301-2.5v-3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 977-4.3301 2.5-4.3301-2.5 4.3301-2.5 4.3301 2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 980-4.3301 2.5v-3l4.3301-2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 977.5-4.3301 2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 977.5 4.3301-2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.92 975v-3l-4.3301 2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 969.5 4.3301 2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.933 972.5 4.3301-2.5 4.3301 2.5-4.3301 2.5z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 974.5 4.3301-2.5-4.3301-2.5",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 969.5-2.6317 1.5194",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 975v2",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.593 972.5v2",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m92.802 979.96c0.32873-0.56938 1.1388-1.3149 1.7081-0.9862l0.46978 0.27719c0.56938 0.32873 0.32873 1.403 0 1.9724-0.32874 0.56938-1.1388 1.3149-1.7082 0.98619l-0.46977-0.27719c-0.56938-0.32873-0.32874-1.403 0-1.9724",
    fill: "#fff",
    stopColor: "#000000",
    style: {
      fill: "#000",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.53 975.59c0.32873-0.56938 1.1388-1.3149 1.7081-0.9862l0.46978 0.27719c0.56938 0.32873 0.32873 1.403 0 1.9724-0.32874 0.56938-1.1388 1.3149-1.7082 0.98619l-0.46977-0.27719c-0.56938-0.32873-0.32874-1.403 0-1.9724",
    fill: "#fff",
    stopColor: "#000000",
    style: {
      fill: "#000",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m38.971 92.5c11.547-6.6667 14.434-8.3333 25.981-15l21.651 12.5",
    fill: "none",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.603 45 4.3301-2.5",
    fill: "none",
    stopColor: "#000000",
    style: {
      fill: "none",
      fontVariationSettings: "normal",
      stroke: "#000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDreamBlack);
export default __webpack_public_path__ + "static/media/Logo_Dream_black.a19e27fafd00fd4c5b3ed6523791636d.svg";
export { ForwardRef as ReactComponent };